import React from 'react';
import { withStore } from 'store';
import { withLayout } from 'hocs';
import MyGuestAddLanding from './MyGuestAddLanding';
import { useWindowSize } from 'hooks';
import BarMobile from 'pages/Header/Content/components/BarMobile';

const MyGuestAddWeb = withLayout(withStore(
  {
    mapStateToProps: (state) => ({
      tableInfo: state.giftTable.giftTable
    }),
  }
)(MyGuestAddLanding));

const MyGuestAddMobile = withStore(
  {
    mapStateToProps: (state) => ({
      tableInfo: state.giftTable.giftTable
    }),
  }
)(MyGuestAddLanding);

function MyGuestAdd() {
  const [, { isMobile }] = useWindowSize();

  return (
    <div>
      {isMobile ? (
        <>
        <BarMobile
          pageName='Lista de invitados'
          marginBottom={32}
        />
        <MyGuestAddMobile />
        </>
      ) : (
        <MyGuestAddWeb />
      )}
    </div>
  );
}

export default MyGuestAdd;
